import {Header, Layout} from "@components/common";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {fetchJson, getShopNavigation, redirectTo404Page} from "./index";
import {useState} from "react";
import Image from "next/image";
import {getStrapiMedia} from "@utils/strapi";
import delve from "dlv";

export function getManagement(locale: string) {
  return new Promise(async (resolve) => {
    let url = `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}/api/managers?populate=*&pagination[page]=1&pagination[pageSize]=100&locale=${locale}`;
    const management: any = await fetchJson(
      url,
      'data'
    );
    resolve(management);
  });
}

export async function getServerSideProps(context: any) {
  try {
    const {locale} = context;
    const management = await getManagement(locale);
    return {
      props: {
        ...(await serverSideTranslations(locale, ["common", "home"])),
        ...(await getShopNavigation(locale)), // makes "ShopNavigationColumn" property available on page props
        management,
        locale
      }
    };
  } catch (error) {
    console.error(error)
    return redirectTo404Page();
  }
}

export default function Management(data: any, U19 = false) {
  let [management, setManagement] = useState(data.management);
  return (
    <div>
      <div className="container-rg">
        <Header></Header>
        <header>
          <h1 className="mb-4">MANAGEMENT</h1>
          <Image
            src="/assets/Header_10.jpg"
            alt="Header image"
            width={1200}
            height={500}
            priority={false}
            quality="100"
          />
        </header>

          <main className="md:flex my-6 lg:items-center">
            {
              management?.map((manager: any, index: any) => {
                return (
                  <>

                  <div className="md:flex-1 content-inner">
                    <h1>{delve(manager, 'attributes.Title') || ""}</h1>
                    <span dangerouslySetInnerHTML={{__html: delve(manager, 'attributes.Description') || ""}}></span>
                  </div>

                  <div key={index} className="md:w-1/3 md:ml-6 mb-6">
                    <Image
                      className="object-cover rounded-xl"
                      src={getStrapiMedia(delve(manager, 'attributes.Image.data.attributes.url')) || ""}
                      alt={delve(manager, 'attributes.Image.data.attributes.alternativeText') || ""}
                      width={600}
                      height={600}
                      priority={false}
                      quality="85"
                    />
                  </div>
                  </>
                )
              })
            }
          </main>

      </div>
    </div>
  )
}

Management.Layout = Layout
